<template>
    <div class="componentRoot" style="width: 100vw; overflow: hidden;">
        <v-container fluid>
            <v-row>
                <v-col style="position: relative">
                    <img src="/images/main/background.jpeg" :style="{
                        height: imageHeight
                    }" style="
                        object-fit: cover; 
                        width: 100%;
                        object-position: bottom;"  alt="Hero Banner Image Mobil" />

                    <div style="position:absolute; top: 50%; transform: translate(0, -50%);"
                        :style="{ 'max-width': maxBannerWidth, 'left': bannerOffset }">
                        <img v-if="!isMobile && !narrowScreen" src="/logo_small_light.png" 
                            style="width: 150px; opacity: 0;" alt="Hero Banner Image Desktop"  />
                        <p style="color: white" v-html="$t('titleScreens.bannerText')"></p>
                        <h1 style="color: white" v-html="$t('titleScreens.landing')"></h1>
                        <v-btn href="/kontakt#contactFormId" flat class="primaryButton mt-4 rounded-xl">{{ $t("landing.contactText2")
                            }}</v-btn><br>
                        <small style="color:rgb(var(--v-theme-light))" class="ml-4">{{ $t("landing.contactButtonText")
                        }}</small>
                    </div>
                </v-col>
            </v-row>

            <WaveVue :color="'rgb(var(--v-theme-background))'" :negative="true"
                style="margin-top: -47px; z-index: 2; position: relative;" :height="WaveHeight"
                :style="{ 'margin-top': WaveMargin }" />

        </v-container>
        <v-container :fluid="$vuetify.display && $vuetify.display.width < 1920" class="py-0" :class="{}"
            style="max-width: 1920px">

            <v-row class="mt-16">
                <v-spacer />
                <v-col :cols="textCols" :style="{ 'margin-left': marginLeftOffset }">
                    <h2>{{ $t("landing.myServices") }}</h2>
                    <p>{{ $t("landing.myServicesText") }}</p>
                </v-col>
                <v-spacer />
            </v-row>

            <v-row class="mb-16">
                <v-spacer />
                <v-col :cols="mainCols2">
                    <v-container fluid class="fill-height">
                        <v-row class="fill-height">
                            <v-col :cols="leftServiceCols">
                                <RouterLink :to="{ name: 'eigenewege' }" custom v-slot="{ href, navigate }">
                                    <LandingCardVue :href="href" @click="navigate" :item="'card2'"
                                    :icon="'/images/icons/02_eigene_wege_finden_1c_n.svg'"
                                    :image="'/images/main/bg-str0.jpg'" class="mb-4" :color="'#018EAC'" 
                                        style="text-decoration: none;" />
                                </RouterLink>


                                <RouterLink :to="{ name: 'staunendlernen' }" custom v-slot="{ href, navigate }">
                                    <LandingCardVue :href="href" @click="navigate" :item="'card1'"
                                    :icon="'/images/icons/01_staunend_lernen_1c_n.svg'"
                                    :image="'/images/main/bg-str1.jpg'" :color="'#628C03'" class="mb-4" 
                                        style="text-decoration: none;" />
                                </RouterLink>

                                <RouterLink :to="{ name: 'freiheitatmen' }" custom v-slot="{ href, navigate }">
                                    <LandingCardVue :href="href" @click="navigate" :item="'card3'"
                                    :image="'/images/main/bg-str2.jpg'" :color="'#53A6AF'"
                                    :icon="'/images/icons/03_freiheit_atmen_1c_2p_V2.svg'" 
                                        style="text-decoration: none;" />
                                </RouterLink>

                            </v-col>
                            <v-col :cols="rightServiceCols">
                                <LandingCardVue :item="'card4'" :image="'/images/main/bg-str3-vert.jpeg'"
                                    :color="'#FA9502'" :icon="'/images/icons/04_lebendig_wachsen_1c_n.svg'"
                                    :direction="'top'" style="height: 100%" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-spacer />
            </v-row>

            <v-row class="lightBackground">
                <WaveVue :height="WaveHeight" style="margin-top: 10px;" />
            </v-row>
            <v-row class="lightBackground py-16">
                <v-spacer />
                <v-col :cols="mainCols">
                    <v-container fluid class="fill-height">
                        <v-row class="fill-height">
                            <v-col :cols="leftAboutMeCols">
                                <v-card flat style="min-height: 150px;" class="mb-4">
                                    <h2>{{ $t("landing.aboutMe") }}</h2>
                                    <p v-html="$t('landing.aboutMeText')"></p>

                                    <v-btn to="/aboutme" class="primaryButton mt-4 rounded-xl" flat>{{
                                        $t('landing.aboutMeButtonText')
                                    }}</v-btn>
                                </v-card>
                            </v-col>
                            <v-col :cols="rightAboutMeCols">
                                <v-card flat style="height: 100%">
                                    <v-img src="/images/main/aboutMe.jpeg" />
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-spacer />
            </v-row>

            <v-row>
                <WaveVue :color="'rgb(var(--v-theme-light))'" :height="WaveHeight" style="margin-top: 10px;" />
            </v-row>


            <v-row class="mt-16">
                <v-spacer />
                <v-col :cols="mainCols" :style="{ 'margin-left': marginLeftOffset }">
                    <h2 id="wayfinder-video-title">{{ $t("landing.wayfinder") }}</h2>
                    <div id="wayfinder-video-description">
                        <p v-for="(paragraph, index) in wayfinderParagraphs" :key="index">{{ paragraph }}</p>
                    </div>
                </v-col>
                <v-spacer />
            </v-row>

            <v-row class="mb-16">
                <v-spacer />
                <v-col :cols="mainCols">

                    <v-container fluid class="fill-height">
                        <v-row class="fill-height">
                            <v-col :cols="12">
                                <v-card flat class="mb-4" style="min-height: 150px;">
                                    <video id="wayfinder-video" controls playsinline preload="metadata"
                                        aria-labelledby="wayfinder-video-title"
                                        aria-describedby="wayfinder-video-description"
                                        poster="/videos/thumbnail.png"
                                        @loadedmetadata="onVideoMetadata"
                                        style="display: block; width: 100%; height: auto;">
                                        <source src="/videos/main.mp4" type="video/mp4" />
                                        {{ $t("landing.videoUnsupported") }}
                                    </video>

                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-spacer />

            </v-row>

        </v-container>
    </div>
</template>



<script>
import LandingCardVue from '../../components/landing/LandingCard.vue';

export default {
    name: "mainRoot",

    data() {
        return {
            // Enter the actual first publication timestamp, including timezone.
            // Example format: YYYY-MM-DDTHH:mm:ss+02:00. Do not use the build date.
            videoUploadDate: null,
            videoDurationSeconds: null,
        }
    },


    computed: {
        wayfinderParagraphs() {
            return String(this.$t("landing.wayfinderText"))
                .split(/\n\s*\n/).filter(paragraph => paragraph.trim());
        },
        videoStructuredData() {
            const published = this.videoUploadDate;
            if (
                typeof published !== "string" ||
                !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(published) ||
                Number.isNaN(Date.parse(published))
            ) return null;

            const data = {
                "@context": "https://schema.org",
                "@type": "VideoObject",
                "@id": "https://www.praxis-keilberg.de/#wayfinder-video",
                name: String(this.$t("landing.wayfinder")),
                description: this.wayfinderParagraphs.join(" "),
                inLanguage: String(this.$i18n.locale),
                thumbnailUrl: "https://www.praxis-keilberg.de/videos/thumbnail.png",
                contentUrl: "https://www.praxis-keilberg.de/videos/main.mp4",
                uploadDate: published,
            };
            if (Number.isFinite(this.videoDurationSeconds) && this.videoDurationSeconds > 0) {
                data.duration = `PT${Math.ceil(this.videoDurationSeconds)}S`;
            }
            return data;
        },
        leftAboutMeCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "12";
                case "lg":
                    return "6";
                case "xl":
                    return "6";
                case "xxl":
                    return "6";
                default:
                    return "6";
            }
        },
        rightAboutMeCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "12";
                case "lg":
                    return "6";
                case "xl":
                    return "6";
                case "xxl":
                    return "6";
                default:
                    return "6";
            }
        },
        leftServiceCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "8";
                case "lg":
                    return "8";
                case "xl":
                    return "8";
                case "xxl":
                    return "8";
                default:
                    return "8";
            }
        },
        rightServiceCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "4";
                case "lg":
                    return "4";
                case "xl":
                    return "4";
                case "xxl":
                    return "4";
                default:
                    return "4";
            }
        },
        marginLeftOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12px";
                case "sm":
                    return "50px";
                case "md":
                    return "50px";
                case "lg":
                    return "100px";
                case "xl":
                    return "50px";
                case "xxl":
                    return "50px";
                default:
                    return "50px";
            }
        },
        imageHeight() {
            let windowHeight = this.$vuetify.display.height
            let cutoffHeight = 500

            switch (this.$vuetify.display.name) {
                case "xs":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "sm":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "md":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "lg":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xxl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                default:
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
            }
        },
        maxBannerWidth() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "90vw";
                case "sm":
                    return "80%";
                case "md":
                    return "50%";
                case "lg":
                    return "30%";
                case "xl":
                    return "30%";
                case "xxl":
                    return "30%"
                default:
                    return "30%"
            }
        },
        bannerOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "10%";
                case "sm":
                    return "10%";
                case "md":
                    return "10%";
                case "lg":
                    return "20%";
                case "xl":
                    return "30%";
                case "xxl":
                    return "30%"
                default:
                    return "30%"
            }
        },
        spacerHeight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "100px";
                case "sm":
                    return "100px";
                case "md":
                    return "100px";
                case "lg":
                    return "100px";
                case "xl":
                    return "100px";
                case "xxl":
                    return "100px";
                default:
                    return "100px";
            }
        },
        WaveHeight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "30px";
                case "sm":
                    return "30px";
                case "md":
                    return "120px";
                case "lg":
                    return "120px";
                case "xl":
                    return "120px";
                case "xxl":
                    return "120px";
                default:
                    return "120px";
            }
        },
        WaveMargin() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "-48px";
                case "sm":
                    return "-48px";
                case "md":
                    return "-138px";
                case "lg":
                    return "-138px";
                case "xl":
                    return "-138px";
                case "xxl":
                    return "-138px";
                default:
                    return "-138px";
            }
        },
        mainCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 10;
                case "lg":
                    return 8;
                case "xl":
                    return 8;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        mainCols2() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 12;
                case "lg":
                    return 10;
                case "xl":
                    return 10;
                case "xxl":
                    return 8;
                default:
                    return 8;
            }
        },
        textCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 10;
                case "sm":
                    return 10;
                case "md":
                    return 10;
                case "lg":
                    return 8;
                case "xl":
                    return 8;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        navCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 2;
                case "sm":
                    return "auto";
                case "md":
                    return "auto";
                case "lg":
                    return "auto";
                case "xl":
                    return "auto";
                case "xxl":
                    return "auto";
                default:
                    return "auto";
            }
        },
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        narrowScreen() {
            return this.$vuetify.display.height < 870
        },
    },

    components: {
        LandingCardVue
    },

    watch: {
        videoStructuredData: {
            deep: true,
            handler() { this.syncVideoStructuredData(); },
        },
    },

    mounted() {
        this.syncVideoStructuredData();
    },

    beforeUnmount() {
        this.removeVideoStructuredData();
    },

    methods: {
        onVideoMetadata(event) {
            const duration = event.target.duration;
            this.videoDurationSeconds = Number.isFinite(duration) && duration > 0
                ? duration : null;
        },
        removeVideoStructuredData() {
            if (this._videoSeoNode) {
                this._videoSeoNode.remove();
                this._videoSeoNode = null;
            }
        },
        syncVideoStructuredData() {
            if (typeof document === "undefined") return;
            const data = this.videoStructuredData;
            if (!data) {
                this.removeVideoStructuredData();
                return;
            }
            if (!this._videoSeoNode) {
                this._videoSeoNode = document.createElement("script");
                this._videoSeoNode.type = "application/ld+json";
                this._videoSeoNode.setAttribute("data-keilberg-video", "wayfinder");
                document.head.appendChild(this._videoSeoNode);
            }
            this._videoSeoNode.textContent = JSON.stringify(data);
        },
    },
}

</script>